import { render, staticRenderFns } from "./BusinessMgmt.vue?vue&type=template&id=58fba98f"
import script from "./BusinessMgmt.vue?vue&type=script&lang=js"
export * from "./BusinessMgmt.vue?vue&type=script&lang=js"
import style0 from "./BusinessMgmt.vue?vue&type=style&index=0&id=58fba98f&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports